import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { take, mergeMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { BasicProfile, BookingRole } from '../../../models';
import { BookingService, LocalStorageService, ProfileService, ToastService } from '../../../services';
import { BookingCurrent } from '../../../store/booking/reducers/booking.reducers';
import { BookModalConfirmedComponent } from './book-modal-confirmed.component';
import { BOOKING_STATUS_RESPONSE } from '../../../pages/bookings/bookings.config';
import { MOBILE_WEB_VIEW, MODAL_DISMISS_REASON } from '../../../utils';
import { selectCurrentBooking } from '../../../store/booking/booking.selectors';
import { BookingActions } from '../../../store/booking/action-types';
import { getBookingFromUrl } from '../../../utils/operators';

@Component({
  template: '',
})
export class BookModalConfirmedEntryComponent implements OnInit, OnDestroy {
  public modalInstance: any;
  public bookModalData: any;
  public modal$: Subscription;
  public sellerInfo$: Subscription;
  public router$: Subscription;

  constructor(
    public bookingService: BookingService,
    private modalService: NgbModal,
    private store: Store,
    private route: ActivatedRoute,
    private router: Router,
    private profileService: ProfileService,
    private toastService: ToastService,
    private localStorageService: LocalStorageService,
  ) {}

  openModal(booking: BookingCurrent, user: BasicProfile): void {
    /* Check if feature is opened from WebView. 
-     If it is, modal close route should have extra query params to indicate WebView exit */
    const openedFromWebView = !!this.localStorageService.get(MOBILE_WEB_VIEW);

    const isSeller = booking.role === BookingRole.SELLER;

    this.modalInstance = this.modalService.open(BookModalConfirmedComponent, {
      windowClass: 'modal-window',
      backdrop: 'static',
    });

    this.modalInstance.componentInstance.fromParent = { booking, user, isSeller, openedFromWebView };
    this.store.dispatch(BookingActions.seenBookingById({ booking: booking.booking }));

    this.modalInstance.result.then(
      () => this.router.navigate(['bookings']),
      (reason: string) => {
        return reason !== MODAL_DISMISS_REASON.ROUTE_SWITCH ? this.router.navigate(['bookings']) : null;
      },
    );
  }

  ngOnInit() {
    const bookingIdRouteParam = this.route.snapshot.params.bookingId;

    //TODO(Mladen): Switch double sub to switchMap concatLatestFrom operators. Napravi action/effect za load basicprofila prema ID-u
    this.modal$ = this.store
      .select(selectCurrentBooking)
      .pipe(
        take(1),
        mergeMap((booking) => getBookingFromUrl(booking, bookingIdRouteParam, this.store)),
      )
      .subscribe((booking) => {
        if (
          bookingIdRouteParam !== booking.booking.id.toString() ||
          booking.booking.status !== BOOKING_STATUS_RESPONSE.CONFIRMED
        ) {
          this.showMessage('Action not allowed for selected booking!');
          this.router.navigate(['bookings']);
        } else {
          const profileId =
            booking.role === BookingRole.SELLER ? booking.booking.booker.profileId : booking.booking.bookee.profileId;
          this.profileService.getBasicProfile(profileId).subscribe((user) => this.openModal(booking, user.body));
        }
      });
  }

  ngOnDestroy() {
    this.modal$.unsubscribe();
    //this.router$.unsubscribe();
  }

  private showMessage(message: string): void {
    this.toastService.showMessage(message);
  }
}
